import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { solicitudesAPI } from '../../services/api';

const SolicitudesList = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('pendiente');

  useEffect(() => {
    loadSolicitudes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroEstado]);

  const loadSolicitudes = async () => {
    try {
      setLoading(true);
      setError('');
      const params = filtroEstado ? { estado: filtroEstado } : {};
      const response = await solicitudesAPI.getAll(params);
      setSolicitudes(response.data);
    } catch (err) {
      setError('Error cargando solicitudes');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '--';
    return new Date(dateStr).toLocaleDateString('es-VE');
  };

  const getEstadoBadge = (estado) => {
    const estilos = {
      pendiente: 'bg-yellow-100 text-yellow-800',
      aprobada: 'bg-green-100 text-green-800',
      rechazada: 'bg-red-100 text-red-800',
    };
    const labels = {
      pendiente: 'Pendiente',
      aprobada: 'Aprobada',
      rechazada: 'Rechazada',
    };
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${estilos[estado] || 'bg-gray-100 text-gray-800'}`}>
        {labels[estado] || estado}
      </span>
    );
  };

  const getRepresentante = (s) => {
    if (s.representante_principal === 'padre' && s.padre_nombre) {
      return `${s.padre_nombre} ${s.padre_apellido || ''}`.trim();
    }
    if (s.representante_principal === 'madre' && s.madre_nombre) {
      return `${s.madre_nombre} ${s.madre_apellido || ''}`.trim();
    }
    if (s.padre_nombre) return `${s.padre_nombre} ${s.padre_apellido || ''}`.trim();
    if (s.madre_nombre) return `${s.madre_nombre} ${s.madre_apellido || ''}`.trim();
    return '--';
  };

  const tabs = [
    { key: 'pendiente', label: 'Pendientes', icon: '⏳' },
    { key: 'aprobada', label: 'Aprobadas', icon: '✅' },
    { key: 'rechazada', label: 'Rechazadas', icon: '❌' },
    { key: '', label: 'Todas', icon: '📋' },
  ];

  return (
    <div>
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Solicitudes de Inscripcion</h1>
          <p className="text-gray-500 text-sm mt-1">Revision y gestion de solicitudes</p>
        </div>
        <Link to="/admin" className="text-lsfc-blue-600 hover:text-lsfc-blue-800 font-medium text-sm">
          ← Volver al Dashboard
        </Link>
      </div>

      {/* Filtro por estado */}
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setFiltroEstado(tab.key)}
            className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
              filtroEstado === tab.key
                ? 'bg-lsfc-blue-600 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
            }`}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {/* Error */}
      {error && (
        <div className="bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg mb-4">
          {error}
        </div>
      )}

      {/* Loading */}
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lsfc-blue-600"></div>
        </div>
      ) : solicitudes.length === 0 ? (
        /* Estado vacío */
        <div className="bg-white rounded-xl shadow-lg p-12 text-center">
          <div className="text-5xl mb-4">📭</div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No hay solicitudes</h3>
          <p className="text-gray-500">
            {filtroEstado === 'pendiente'
              ? 'No hay solicitudes pendientes por revisar'
              : filtroEstado === 'aprobada'
              ? 'No hay solicitudes aprobadas'
              : filtroEstado === 'rechazada'
              ? 'No hay solicitudes rechazadas'
              : 'No se encontraron solicitudes'}
          </p>
        </div>
      ) : (
        /* Tabla */
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="p-4 border-b border-gray-200">
            <p className="text-sm text-gray-600">
              {solicitudes.length} solicitud{solicitudes.length !== 1 ? 'es' : ''} encontrada{solicitudes.length !== 1 ? 's' : ''}
            </p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Alumno</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase hidden md:table-cell">Cedula</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase hidden lg:table-cell">F. Nacimiento</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase hidden md:table-cell">Representante</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase hidden lg:table-cell">Fecha Solicitud</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Accion</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {solicitudes.map((s) => (
                  <tr key={s.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-4">
                      <div>
                        <p className="font-semibold text-gray-900">{s.apellidos} {s.nombres}</p>
                        <p className="text-xs text-gray-500 md:hidden">{s.cedula || 'Sin cedula'}</p>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-700 hidden md:table-cell">
                      {s.cedula || <span className="text-gray-400 italic">Sin cedula</span>}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-700 hidden lg:table-cell">
                      {formatDate(s.fecha_nacimiento)}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-700 hidden md:table-cell">
                      {getRepresentante(s)}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-700 hidden lg:table-cell">
                      {formatDate(s.created_at)}
                    </td>
                    <td className="px-4 py-4">
                      {getEstadoBadge(s.estado)}
                    </td>
                    <td className="px-4 py-4 text-center">
                      <Link
                        to={`/admin/solicitudes/${s.id}`}
                        className="inline-flex items-center gap-1 px-3 py-1.5 bg-lsfc-blue-50 text-lsfc-blue-700 rounded-lg hover:bg-lsfc-blue-100 text-sm font-medium transition-all"
                      >
                        Ver
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SolicitudesList;
